import { render } from "./SearchList.vue?vue&type=template&id=61cfbd1a&scoped=true"
import script from "./SearchList.vue?vue&type=script&lang=js"
export * from "./SearchList.vue?vue&type=script&lang=js"

import "./SearchList.vue?vue&type=style&index=0&id=61cfbd1a&lang=scss&scoped=true"

import exportComponent from "D:\\digitalnewspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61cfbd1a"]])

export default __exports__